import React, { useMemo } from 'react'
import { Table } from '@bedrock/components'
import { OaAuditNodes, OANode } from './index'
import POPOUserList from './POPOUserList'
import styles from './index.less'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

type ProcessItem = {
    node_name: string,
} & OaAuditNodes

type OaDetailTableProps = {
    processList: OANode[],
    loading?: boolean,
}

const getColor = (status: string) => {
    switch (status) {
        case 'AUDITING':
            return 'var(--status-warning-1)';
        case 'START':
        case 'APPROVED':
        case 'PRE_ADD_SIGN':
        case 'POST_ADD_SIGN':
        case 'REASSIGN':
        case 'SYSTEM_REASSIGN':
        case 'AUTO_COMPLETED':
        case 'END':
        case 'COPYFOR':
            return 'var(--status-success-1)';
        case 'RETURN':
        case 'TERMINATE':
        case 'ABORT':
            return 'var(--status-danger-1)';
        default:
            return 'var(--text-color-1)';
    }
}

const combinJobNum = (list = []) => {
    return list?.map?.(item => ({
        ...item, 
        name: `${item.name}${item?.job_number ? `（${item?.job_number}）` : ''}`,
    }))
}

export default function OAProgressTable({ processList, loading }: OaDetailTableProps) {
    const showList: ProcessItem[] = useMemo(() => {
        let list = []
        processList?.forEach?.((item, index) => {
            let node_name = item.node_name
            item.oa_audit_nodes?.forEach((node, index) => {
                list.push({
                    node_name: node_name,
                    ...node,
                })
            })
        })
        return list.reverse();
    }, [processList])

    return <div style={{ width: '100%' }} className={cx('oa-progress-table')} >
        <Table
            isShowLoading={loading}
            data={showList}
            scroll={{ x: 'max-content' }}
            emptyText='暂无数据'
            columns={[
                { title: '节点', width: 100, align: 'left', dataIndex: 'node_name', onCell: () => ({ style: { 'fontWeight': 'bold' } })  },
                { title: '操作', width: 100, align: 'left', dataIndex: 'op', onCell: (record) => ({ style: { color: getColor(record.op_type) } }) },
                { title: '审批时间', width: 150, align: 'left', dataIndex: 'audit_time', onCell: () => ({ style: { color: 'var(--text-color-3)' } }) },
                {
                    title: '操作人', width: 100, align: 'left', dataIndex: 'audit_users',
                    render: (v) => v?.length ? <POPOUserList list={combinJobNum(v)} /> : '--',
                },
                {
                    title: '接收人', width: 100, align: 'left', dataIndex: 'receive_users',
                    render: (v) => v?.length ? <POPOUserList list={combinJobNum(v)} /> : '--',
                },
                { title: '审批意见', width: 100, align: 'left', dataIndex: 'suggest' },
            ]}
        />
    </div>
}
